import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import CookieConsent from 'react-cookie-consent';

// Utils
import { contactEmail, cookieBannerEs, cookieBannerEn } from '../helpers';

// Hook
import useTermsAndConditions from '../hooks/useTermsAndConditions';
import useLanguage from '../hooks/useLanguage';

function Footer(props) {
  const { t } = props;
  const { locale } = useLanguage();
  const { terms } = useTermsAndConditions();
  return (
    <>
      <CookieConsent
        location="bottom"
        buttonText={t('footer:accept-cookie')}
        cookieName="leo.com"
        containerClasses="cookie_banner--content"
        style={{ background: '#0B4352', color: '#ffffff' }}
        buttonStyle={{ color: '#0F1E2A', background: '#FFFFFFB3', fontSize: '14px' }}
        expires={365}
      >
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: locale === 'es' ? cookieBannerEs() : cookieBannerEn() }}
        />
      </CookieConsent>
      <div className="footer row">
        <div className="row col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="pull-right uppercase col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <p className="footer-title">{t('footer:title-contact')}</p>
            <p className="footer-p">{t('footer:contact')}</p>
            <p className="footer-p contact">
              <a href={`mailto:${contactEmail()}`}>
                <strong> {contactEmail()} </strong>
              </a>
            </p>
          </div>
          <div className="pull-right uppercase col-lg-8 col-md-8 col-sm-12 col-xs-12">
            <p className="footer-title">{t('footer:title-terms')}</p>
            <div className="items-terms">
              {terms.map((term) => (
                <p className="footer-p" value={term.id} key={term.id}>
                  <Link to={`/${locale}/${t('routers:Terms')}/${term.slug}`}>{term.title} </Link>
                </p>
              ))}
            </div>
          </div>
        </div>
        <div className="row bottom col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="copyright col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <p className="footer-txt">
              2021 © LEO S.A.
              {t('footer:autor')}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

Footer.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['footer', 'routers'])(Footer);
